module.exports = __webpack_public_path__ + "static/media/view1.d7a1fda4.jpg";